import { AccountModel, BillToModel, ProductPriceDto, ShipToCollectionModel, ShipToModel } from "@insite/client-framework/Types/ApiModels";

export const defaultAccountModel: AccountModel = {
    accessToken: "",
    activationStatus: "",
    approver: "",
    availableApprovers: null,
    availableRoles: null,
    availableRolesTranslated: null,
    billToId: null,
    canApproveOrders: false,
    canViewApprovalOrders: false,
    defaultCustomerId: null,
    defaultFulfillmentMethod: "",
    defaultWarehouse: null,
    defaultWarehouseId: null,
    email: "",
    firstName: "",
    id: "",
    isApproved: null,
    isGuest: false,
    isSubscribed: null,
    lastLoginOn: null,
    lastName: "",
    password: "",
    requiresActivation: null,
    role: "",
    roleTranslated: "",
    setDefaultCustomer: false,
    shipToId: null,
    userName: "",
    vmiRole: "",
    vmiRoleTranslated: "",
    uri: "",
    properties: {}
}

export const defaultBillToModel: BillToModel = {
    address1: '',
    address2: '',
    address3: '',
    address4: '',
    city: '',
    postalCode: '',
    attention: '',
    budgetEnforcementLevel: '',
    companyName: '',
    contactFullName: '',
    costCodeTitle: '',
    country: null,
    customerCurrencySymbol: '',
    customerName: '',
    customerNumber: '',
    customerSequence: '',
    email: '',
    fax: '',
    firstName: '',
    lastName: '',
    fullAddress: '',
    id: '',
    isDefault: true,
    isGuest: false,
    label: '',
    phone: '',
    shipTosUri: '',
    state: null,
    uri: '',
    properties: {},
}

export const defaultShipToModel: ShipToModel = {
    address1: '',
    address2: '',
    address3: '',
    address4: '',
    city: '',
    postalCode: '',
    attention: '',
    companyName: '',
    contactFullName: '',
    country: null,
    customerName: '',
    customerNumber: '',
    customerSequence: '',
    email: '',
    fax: '',
    firstName: '',
    lastName: '',
    fullAddress: '',
    id: '',
    isDefault: true,
    label: '',
    phone: '',
    state: null,
    uri: '',
    properties: {},
    isNew: false,
    isVmiLocation: false,
    oneTimeAddress: false,
    validation: null,
}

export const defaultShipToCollectionModel: ShipToCollectionModel = {
    pagination: null,
    shipTos: [],
    uri: '',
    properties: {},
}

export const defaultProductPricingDTO: ProductPriceDto = {
    actualBreakPrices: null,
    actualPrice: 0,
    actualPriceDisplay: "",
    additionalResults: null,
    extendedActualPrice: 0,
    extendedActualPriceDisplay: "",
    extendedRegularPrice: 0,
    extendedRegularPriceDisplay: "",
    extendedUnitListPrice: 0,
    extendedUnitListPriceDisplay: "",
    extendedUnitListPriceWithVat: 0,
    extendedUnitListPriceWithVatDisplay: "",
    extendedUnitNetPrice: 0,
    extendedUnitNetPriceDisplay: "",
    extendedUnitRegularPrice: 0,
    extendedUnitRegularPriceDisplay: "",
    extendedUnitRegularPriceWithVat: 0,
    extendedUnitRegularPriceWithVatDisplay: "",
    isOnSale: false,
    productId: "",
    regularBreakPrices: null,
    regularPrice: 0,
    regularPriceDisplay: "",
    requiresRealTimePrice: false,
    unitCost: 0,
    unitCostDisplay: "",
    unitListBreakPrices: null,
    unitListPrice: 0,
    unitListPriceDisplay: "",
    unitListPriceWithVat: 0,
    unitListPriceWithVatDisplay: "",
    unitNetPrice: 0,
    unitNetPriceDisplay: "",
    unitOfMeasure: "",
    unitRegularBreakPrices: null,
    unitRegularPrice: 0,
    unitRegularPriceDisplay: "",
    unitRegularPriceWithVat: 0,
    unitRegularPriceWithVatDisplay: "",
    vatAmount: 0,
    vatAmountDisplay: "",
    vatMinusExtendedUnitRegularPrice: 0,
    vatRate: 0
}